import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import facebookSelectors from "modules/facebook/selectors";
import dateFormatter from "modules/utils/DateFormatter";

const CRMConversionSheets = () => {
  const [t] = useTranslation();
  const googleSheetsCRMConversionsLastSendResult = useSelector((state) =>
    facebookSelectors.getGoogleSheetsCRMConversionsLastSendResult(state),
  );
  const [lastSentGSheetsConversion1, setLastSentGSheetsConversion1] = useState(false);
  const [lastSentGSheetsConversion2, setLastSentGSheetsConversion2] = useState(false);
  const [lastSentGSheetsConversion3, setLastSentGSheetsConversion3] = useState(false);
  const [lastSentGSheetsConversion4, setLastSentGSheetsConversion4] = useState(false);
  const [lastSentGSheetsConversion5, setLastSentGSheetsConversion5] = useState(false);
  const [lastSentGSheetsConversion6, setLastSentGSheetsConversion6] = useState(false);
  const [lastSentGSheetsConversion7, setLastSentGSheetsConversion7] = useState(false);
  const [lastSentGSheetsConversion8, setLastSentGSheetsConversion8] = useState(false);
  const [lastSentGSheetsConversion9, setLastSentGSheetsConversion9] = useState(false);
  const [lastSentGSheetsConversion10, setLastSentGSheetsConversion10] = useState(false);

  const conversionMappings = {
    "GSheets-Conversion1": {
      leadStep: "Conversion 1",
      conversionName: "GSheets-Conversion1",
      setLastSent: setLastSentGSheetsConversion1,
      lastSent: lastSentGSheetsConversion1,
    },
    "GSheets-Conversion2": {
      leadStep: "Conversion 2",
      conversionName: "GSheets-Conversion2",
      setLastSent: setLastSentGSheetsConversion2,
      lastSent: lastSentGSheetsConversion2,
    },
    "GSheets-Conversion3": {
      leadStep: "Conversion 3",
      conversionName: "GSheets-Conversion3",
      setLastSent: setLastSentGSheetsConversion3,
      lastSent: lastSentGSheetsConversion3,
    },
    "GSheets-Conversion4": {
      leadStep: "Conversion 4",
      conversionName: "GSheets-Conversion4",
      setLastSent: setLastSentGSheetsConversion4,
      lastSent: lastSentGSheetsConversion4,
    },
    "GSheets-Conversion5": {
      leadStep: "Conversion 5",
      conversionName: "GSheets-Conversion5",
      setLastSent: setLastSentGSheetsConversion5,
      lastSent: lastSentGSheetsConversion5,
    },
    "GSheets-Conversion6": {
      leadStep: "Conversion 6",
      conversionName: "GSheets-Conversion6",
      setLastSent: setLastSentGSheetsConversion6,
      lastSent: lastSentGSheetsConversion6,
    },
    "GSheets-Conversion7": {
      leadStep: "Conversion 7",
      conversionName: "GSheets-Conversion7",
      setLastSent: setLastSentGSheetsConversion7,
      lastSent: lastSentGSheetsConversion7,
    },
    "GSheets-Conversion8": {
      leadStep: "Conversion 8",
      conversionName: "GSheets-Conversion8",
      setLastSent: setLastSentGSheetsConversion8,
      lastSent: lastSentGSheetsConversion8,
    },
    "GSheets-Conversion9": {
      leadStep: "Conversion 9",
      conversionName: "GSheets-Conversion9",
      setLastSent: setLastSentGSheetsConversion9,
      lastSent: lastSentGSheetsConversion9,
    },
    "GSheets-Conversion10": {
      leadStep: "Conversion 10",
      conversionName: "GSheets-Conversion10",
      setLastSent: setLastSentGSheetsConversion10,
      lastSent: lastSentGSheetsConversion10,
    },
  };

  useEffect(() => {
    if (
      googleSheetsCRMConversionsLastSendResult.result === 0 &&
      googleSheetsCRMConversionsLastSendResult.data.length > 0
    ) {
      googleSheetsCRMConversionsLastSendResult.data.map((item) => {
        const conversionMapping = conversionMappings[item.conversion_name];
        if (conversionMapping) {
          let { setLastSent } = conversionMapping;
          setLastSent(dateFormatter.formatDatetimeFull(item.last_sent_datetime, sessionStorage.getItem("lang")));
        }
      });
    }
  }, [googleSheetsCRMConversionsLastSendResult]);

  const view = () => {
    return (
      <>
        <Description>{t("__fbads_google_sheets_description")}</Description>

        <Table>
          <thead>
            <tr>
              <th className="google-sheets-title" colSpan="1">
                Google Sheets
              </th>
              <th className="google-ads-title" colSpan="1">
                Meta Ads
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="sub-title">{t("__lead_step")}</td>
              <td className="sub-title">{t("__ads_google_sheets_conversion_name")}</td>
            </tr>
            {Object.keys(conversionMappings).map((key, index) => {
              return (
                <tr key={index}>
                  <td className="text-left">{conversionMappings[key].leadStep}</td>
                  <td className="text-left">
                    <div>{conversionMappings[key].conversionName}</div>
                    <div className="secondary-text">
                      {t("__last_updated")}
                      {conversionMappings[key].lastSent
                        ? conversionMappings[key].lastSent
                        : t("__fbads_conversion_no_data")}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </>
    );
  };
  return view();
};

export default CRMConversionSheets;

const Description = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  color: #999;
`;

const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #eee;
  width: 100%;
  font-size: 14px;

  th,
  td {
    border: 1px solid #eee;
    padding: 10px;
    width: 50%;
  }

  .sub-title {
    background-color: #f9f9f9;
    color: #555;
    /* font-size: 12px; */
    text-align: center;
    /* padding: 5px 10px; */
  }

  .google-sheets-title {
    color: #fff;
    background-color: #2196f3;
    width: 40%;
  }

  .google-ads-title {
    color: #fff;
    background-color: #4caf50;
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }
`;
